import styled from 'styled-components';

export const DueDateContainer = styled.div`
  margin-bottom: 16px;
  padding: 12px;
  background-color: #2C333A; // Slightly different background to stand out
  border-radius: 4px;
  color: #B6C2CF;
`;

export const DueDateInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap; // Allow wrapping for smaller screens
  gap: 8px; // Add some gap for wrapped items
`;

export const DueDateText = styled.span`
  font-size: 15px; // Slightly larger
  font-weight: 600; // Bolder
  margin-right: 16px;
  flex-shrink: 0; // Prevent shrinking if space is tight before wrapping

  &.completed {
    text-decoration: line-through;
    color: #7A869A; // Dim color for completed
  }
`;

export const DueDateStatusWrapper = styled.div` // Renamed from DueDateStatus
  display: flex;
  align-items: center;
  gap: 12px; // Gap between status text and checkbox area
`;

export const DueDateStatusText = styled.span`
  font-size: 12px;
  font-weight: bold;
  padding: 3px 6px;
  border-radius: 3px;
  color: white; // Default text color for badge
  background-color: ${props => props.color || '#6B778C'}; // Default background color
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const DueDateActions = styled.div` // New wrapper for checkbox + label
  display: flex;
  align-items: center;
`;

export const DueDateCheckbox = styled.input`
  width: 16px;
  height: 16px;
  margin-right: 8px;
  cursor: pointer;
  accent-color: #0079BF; // Matches button colors for consistency
`;

export const DueDateLabel = styled.label`
  font-size: 14px;
  cursor: pointer;
  color: #B6C2CF; // Match general text color
`;
